import { createContext } from 'react';
import type { ChatChannel } from '@shared/schemas/chat.schema.js';
import type { ChannelHistory } from './chatReducer';

/** The one chat of the island: its state, and everything that can be done with it. */
export interface ChatContextValue {
  channels: ChatChannel[];
  /** Unread messages per channel id; the channel on screen never has any. */
  unreadCounts: Record<string, number>;
  /** The sum of `unreadCounts`, for the chat button's badge. */
  totalUnread: number;
  /** Whether the chat drawer is open. */
  isOpen: boolean;
  /** The channel the drawer shows. */
  activeChannel: ChatChannel | null;
  /** What is held of the active channel, or null when there is none. */
  history: ChannelHistory | null;
  /** A chat failure with nowhere else to show it (a DM that did not open). */
  notice: string | null;

  open: () => void;
  close: () => void;
  toggle: () => void;
  selectChannel: (channelId: string) => void;
  startDm: (userId: string) => void;
  sendMessage: (content: string) => void;
  /** Send one of our failed messages again. */
  retryMessage: (messageId: string) => void;
  /** Join the channel on screen again, after its join failed. */
  retryJoin: () => void;
  /** Load the page before the oldest message held of the channel on screen. */
  loadOlderMessages: () => void;
  dismissNotice: () => void;
}

export const ChatContext = createContext<ChatContextValue | null>(null);
